import { __awaiter, __decorate } from "tslib";
import { Component, HostListener, Pipe, ViewChild, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '../../../services/language.service';
import { ComponentService } from '../../../services/component.service';
import { CreateWalletModalComponent } from "../create-wallet-modal/create-wallet-modal.component";
import { WelcomeWalletModalComponent } from "../welcome-wallet-modal/welcome-wallet-modal.component";
import { DepositWalletModalComponent } from "../deposit-wallet-modal/deposit-wallet-modal.component";
import { DepositWalletAudModalComponent } from "../deposit-wallet-modal/deposit-wallet-aud-modal.component";
import { WithdrawWalletModalComponent } from "../withdraw-wallet-modal/withdraw-wallet-modal.component";
import { WithdrawWalletAudModalComponent } from "../withdraw-wallet-modal/withdraw-wallet-aud-modal.component";
import { CoinFiatWalletModalComponent } from "../coin-fiat-wallet-modal/coin-fiat-wallet-modal.component";
import { WebClientService } from '../../../services/webclient-settings.service';
import { WalletServiceNotAvailableComponent } from "../wallet-service-not-available-modal/wallet-service-not-available-modal";
import { BuyWalletModalComponent } from "../buy-wallet-modal/buy-wallet-modal.component";
import { SellWalletModalComponent } from "../sell-wallet-modal/sell-wallet-modal.component";
import { ResetWalletPasswordModalComponent } from "../reset-wallet-password-modal/reset-wallet-password-modal.component";
import { AuthenticationWalletModalComponent } from "../authentication-wallet-modal/authentication-wallet-modal.component";
import { UpdateUserDataWalletModalComponent } from '../update-user-data-wallet-modal/update-user-data-wallet-modal.component';
import { WalletDocumentExpirationModalComponent } from '../wallet-document-expiration-modal/wallet-document-expiration-modal.component';
import { ResetMfaMessageModalComponent } from '../reset-mfa-message-modal/reset-mfa-message-modal.component';
import { BuyBasketWalletModalComponent } from "../buy-basket-wallet-modal/buy-basket-wallet-modal.component";
import { AuthService } from "../../../services/auth.service";
import { DepositOriginService } from '../../../services/deposit-origin.service';
import { InfoModalComponent } from "../info-modal/info-modal.component";
import { ConvertWalletModalComponent } from "../convert-wallet-modal/convert-wallet-modal.component";
import { forkJoin } from "rxjs";
let NoCommaPipe = class NoCommaPipe {
    constructor(webSettingsService) {
        this.webSettingsService = webSettingsService;
        this.thousandsSeparator = '';
        this.decimalSeparator = '';
    }
    transform(val) {
        this.thousandsSeparator = this.webSettingsService.getWebSetting('NUMBER_FORMAT.THOUSANDS_SEPARATOR');
        this.decimalSeparator = this.webSettingsService.getWebSetting('NUMBER_FORMAT.DECIMAL_SEPARATOR');
        if (val !== undefined && val !== null) {
            let decimalSeparator = "\\" + this.decimalSeparator;
            let regex = new RegExp(decimalSeparator, "g");
            let temp = (val.toString().replace(regex, this.thousandsSeparator));
            let lastDotOrComma = temp.lastIndexOf(this.thousandsSeparator);
            if (lastDotOrComma >= 0) {
                let hasRemainder = this.checkIfHasRemainder(temp, lastDotOrComma);
                if (hasRemainder) {
                    return temp.substring(0, lastDotOrComma) + this.decimalSeparator + temp.substring(lastDotOrComma + 1, temp.length);
                }
                else {
                    return temp.substring(0, lastDotOrComma);
                }
            }
            return temp;
        }
        else {
            return "";
        }
    }
    checkIfHasRemainder(num, lastDot) {
        let remainder = num.substring(lastDot + 1, num.length);
        let hasRemainder = false;
        for (let i = 0; i < remainder.length; i++) {
            if (remainder[i] != '0') {
                hasRemainder = true;
            }
        }
        return hasRemainder;
    }
};
NoCommaPipe.ctorParameters = () => [
    { type: WebClientService }
];
NoCommaPipe = __decorate([
    Pipe({
        name: 'noComma'
    })
], NoCommaPipe);
export { NoCommaPipe };
/**
 * Wallet Cryptocurrencies Component
 */
let WalletCryptocurrenciesComponent = class WalletCryptocurrenciesComponent {
    constructor(httpClient, sanitizer, route, themeService, router, languageService, webSettingsService, compService, auth, depositOriginService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.route = route;
        this.themeService = themeService;
        this.router = router;
        this.languageService = languageService;
        this.webSettingsService = webSettingsService;
        this.compService = compService;
        this.auth = auth;
        this.depositOriginService = depositOriginService;
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.secondColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.secondaryColor = '';
        this.linkColor = '';
        this.inputBackColor = '';
        this.activeCurrency = localStorage.getItem('defaultCurrency').toLowerCase();
        this.defaultCurrency = localStorage.getItem('defaultCurrency');
        this.searchCrypto = '';
        this.user = JSON.parse(localStorage.getItem('user'));
        this.errorMessage = '';
        this.hasWallet = false;
        this.wallets = [];
        this.accountData = [];
        this.allCurrencies = [];
        this.showingCurrencies = [];
        this.currenciesAndWallets = [];
        this.slice = 10;
        this.prices = {};
        this.priceChanges = {};
        this.myBalance = 0;
        this.primaryMyBalance = 0;
        this.priceChanged = false;
        this.priceChart = [];
        this.fiatWallets = [];
        this.hasFiatSpendableTotal = false;
        this.hasFiatCurrency = false;
        this.isWalletsLoaded = false;
        this.baskets = [];
        this.questionnaireSubmitted = true;
        this.marketFee = 0;
        this.allowedDecimalPlaces = localStorage.getItem('allowedDecimalPlaces');
        this.previousUrl = '';
        this.modalOpened = false;
        this.openIndex = null;
        this.isBasketProcessed = false;
        this.allWallets = [];
        this.auth.fetchUser().then(result => {
            this.user = JSON.parse(localStorage.getItem('user'));
            if (!this.user || !this.user.eligible_for_wallet) {
                this.router.navigateByUrl('');
            }
            if ((!this.user.personally_validated && this.user.user_type_id.type !== 'lite_verified') || this.user.api_mfa_enabled != 1) {
                this.compService.openModal(WelcomeWalletModalComponent);
            }
            if (this.user.wallet_blocked) {
                var resetMfaMessageModalComponentShownOnStart = localStorage.getItem('ResetMfaMessageModalComponentShownOnStart');
                if (resetMfaMessageModalComponentShownOnStart === null ||
                    resetMfaMessageModalComponentShownOnStart === undefined ||
                    resetMfaMessageModalComponentShownOnStart == '0') {
                    this.compService.openModal(ResetMfaMessageModalComponent);
                    this.compService.componentRef.onDestroy(() => {
                        localStorage.setItem('ResetMfaMessageModalComponentShownOnStart', '1');
                    });
                }
            }
            if (this.token) {
                this.httpClient.get('user/resetpasswordconfirm/' + this.token).subscribe((data) => {
                    this.compService.openModal(ResetWalletPasswordModalComponent, {
                        token: this.token,
                        step: 3
                    });
                }, (error) => {
                    this.compService.openModal(AuthenticationWalletModalComponent, {
                        authenticated: true,
                        type: 'wallet_passphrase_reset',
                        isSuccess: false
                    });
                });
            }
        });
        this.route.params.subscribe((params) => {
            this.token = params['token'];
        });
        this.innerWidth = window.innerWidth;
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.secondaryColor = this.themeService.getStyleAttribute('secondary_text_color');
        });
        this.webSettingsService.getSettings().subscribe((data) => {
            this.sliceFromSetting = Number(this.webSettingsService.getWebSetting('WALLET.PAGINATION.NUMBER_OF_WALLETS'));
            this.slice = this.sliceFromSetting;
        });
        this.route.data.subscribe(data => {
            this.showXStock = data['showXStock'];
            this.showBasket = data['showBasket'];
            this.showBalance = data['showBalance'];
        });
    }
    ngOnInit() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
        this.httpClient.get('wallet/getaccounts').subscribe((data) => __awaiter(this, void 0, void 0, function* () {
            if (data['accounts'] && data['accounts'].length > 0) {
                this.accountData = data['accounts'][0];
                if (this.accountData['wallets']) {
                    this.allWallets = this.accountData['wallets'].filter(wallet => wallet.wallet.currency.defaultChain === true);
                    this.wallets = this.accountData['wallets'].filter(wallet => wallet.wallet.currency.defaultChain === true && wallet.wallet.currency.xstock === this.showXStock);
                }
                if (this.webSettingsService.applySettings('WALLET.INFO_MODAL.VISIBLE') && !localStorage.getItem('wallet_info_modal_viewed')) {
                    this.compService.openModal(InfoModalComponent);
                }
                this.getPossibleConvertPairs();
                if (this.showBasket) {
                    this.loadBaskets();
                }
                yield this.loadAll();
                this.refreshInterval = setInterval(() => {
                    this.refreshData();
                }, 15000);
            }
            else if (data['accounts'] && data['accounts'].length === 0) {
                if ((this.user.personally_validated || this.user.user_type_id.type === 'lite_verified') && this.user.api_mfa_enabled) {
                    this.compService.openModal(CreateWalletModalComponent, null, () => { this.ngOnInit(); });
                }
            }
        }), (error) => {
            if (error.status === 500) {
                this.compService.openModal(WalletServiceNotAvailableComponent);
            }
        });
    }
    loadAll() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const [prices, currencies, priceChart] = yield forkJoin([
                this.httpClient.get('market/pricesforwallet'),
                this.httpClient.get('wallet/getallcurrencies'),
                this.httpClient.get('market/getlastsevendayschanges'),
            ]).toPromise();
            this.prices = prices;
            this.priceChanges = (_a = this.prices) === null || _a === void 0 ? void 0 : _a.daily_price_changes;
            this.allCurrencies = currencies === null || currencies === void 0 ? void 0 : currencies.currencies;
            this.showingCurrencies = currencies === null || currencies === void 0 ? void 0 : currencies.currencies.filter(currency => currency.xstock === this.showXStock);
            this.hasFiatCurrency = this.allCurrencies.some(currency => currency.fiat === true);
            this.priceChart = priceChart === null || priceChart === void 0 ? void 0 : priceChart.prices;
            if (this.baskets.length > 0) {
                this.processBasket();
            }
            this.processWallet();
        });
    }
    loadBaskets() {
        return this.httpClient.get('wallet/getbaskets').subscribe((data) => __awaiter(this, void 0, void 0, function* () {
            if (data) {
                yield this.getMarketFee();
                this.baskets = data;
                if (Object.keys(this.prices).length > 0) {
                    this.processBasket();
                }
            }
        }));
    }
    getMarketFee() {
        return __awaiter(this, void 0, void 0, function* () {
            this.httpClient.get('order/marketfee').subscribe((data) => {
                this.marketFee = data['message'];
            });
        });
    }
    refreshData(manualRefresh = false) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.isWalletsLoaded = false;
            if (manualRefresh) {
                const [wallets, prices, currencies, priceChart] = yield forkJoin([
                    this.httpClient.get('wallet/getwallets'),
                    this.httpClient.get('market/pricesforwallet'),
                    this.httpClient.get('wallet/getallcurrencies'),
                    this.httpClient.get('market/getlastsevendayschanges')
                ]).toPromise();
                this.allWallets = this.accountData['wallets'].filter(wallet => wallet.wallet.currency.defaultChain === true);
                this.wallets = wallets === null || wallets === void 0 ? void 0 : wallets.wallets.filter((w) => { var _a, _b, _c, _d; return ((_b = (_a = w === null || w === void 0 ? void 0 : w.wallet) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.defaultChain) === true && ((_d = (_c = w === null || w === void 0 ? void 0 : w.wallet) === null || _c === void 0 ? void 0 : _c.currency) === null || _d === void 0 ? void 0 : _d.xstock) === this.showXStock; });
                this.prices = prices;
                this.priceChanges = (_a = this.prices) === null || _a === void 0 ? void 0 : _a.daily_price_changes;
                this.allCurrencies = currencies === null || currencies === void 0 ? void 0 : currencies.currencies;
                this.showingCurrencies = currencies === null || currencies === void 0 ? void 0 : currencies.currencies.filter(currency => currency.xstock === this.showXStock);
                this.hasFiatCurrency = this.allCurrencies.some(currency => currency.fiat === true);
                this.priceChart = priceChart === null || priceChart === void 0 ? void 0 : priceChart.prices;
            }
            else {
                const [wallets, prices] = yield forkJoin([
                    this.httpClient.get('wallet/getwallets'),
                    this.httpClient.get('market/pricesforwallet')
                ]).toPromise();
                this.allWallets = this.accountData['wallets'].filter(wallet => wallet.wallet.currency.defaultChain === true);
                this.wallets = wallets === null || wallets === void 0 ? void 0 : wallets.wallets.filter((w) => { var _a, _b, _c, _d; return ((_b = (_a = w === null || w === void 0 ? void 0 : w.wallet) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.defaultChain) === true && ((_d = (_c = w === null || w === void 0 ? void 0 : w.wallet) === null || _c === void 0 ? void 0 : _c.currency) === null || _d === void 0 ? void 0 : _d.xstock) === this.showXStock; });
                this.prices = prices;
                this.priceChanges = (_b = this.prices) === null || _b === void 0 ? void 0 : _b.daily_price_changes;
            }
            this.processBasket();
            this.processWallet();
        });
    }
    processBasket() {
        const fiatWallet = this.wallets.find(wallet => wallet.wallet.currency.fiat);
        this.baskets.forEach(basket => {
            basket.fiatAmountEnoughForBasket = fiatWallet && fiatWallet.wallet.spendableTotal >= basket.price;
            basket.ecurrency_basket.forEach(ecurrencyBasket => {
                ecurrencyBasket.currencyPrice = Number(this.prices[this.defaultCurrency.toLowerCase() + '_prices'][ecurrencyBasket.ecurrency.code]);
                ecurrencyBasket.amount = basket.price * ecurrencyBasket.percentage / 100;
                ecurrencyBasket.amountReceive = this.calculateBasketAmount(ecurrencyBasket, ecurrencyBasket.amount, ecurrencyBasket.currencyPrice);
            });
        });
        this.isBasketProcessed = true;
    }
    processWallet() {
        const tempCurrenciesAndWallets = this.showingCurrencies.map(currency => this.createWalletData(currency));
        this.currenciesAndWallets = this.sortWallets(tempCurrenciesAndWallets);
        const fiatWallet = this.allWallets.find(wallet => wallet.wallet.currency.fiat === true);
        if (fiatWallet && fiatWallet.wallet.spendableTotal > 0) {
            this.hasFiatSpendableTotal = true;
        }
        this.isWalletsLoaded = true;
        if (this.currenciesAndWallets.length) {
            this.openModalFromRoute();
        }
        this.setCurrency(this.activeCurrency);
    }
    createWalletData(currency) {
        var _a;
        const priceChart = this.getPriceChart(currency.verboseId);
        const priceTrend = this.getPriceTrend(currency.verboseId);
        const tempWalletData = {
            currency,
            currencyShort: currency.verboseId.toLowerCase(),
            wallet: ((_a = this.wallets) === null || _a === void 0 ? void 0 : _a.find(wallet => wallet.wallet.currency.verboseId === currency.verboseId)) || null,
            priceChart,
            maxDifference: this.maxDifference(priceChart),
            chartColor: priceTrend === 'up' ? 'green' : (priceTrend === 'down' ? 'red' : 'black'),
        };
        return tempWalletData;
    }
    ngAfterViewInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.previousUrl = window.history.state.redirect;
        });
    }
    ngOnDestroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }
    onResize(event) {
        this.innerWidth = window.innerWidth;
    }
    setCurrency(currency) {
        this.priceChanged = false;
        this.myBalance = 0;
        this.primaryMyBalance = 0;
        this.calculateFiatBalance(this.allWallets, this.prices, currency);
        this.primaryMyBalance = this.myBalance / this.prices[currency + '_prices']['btc'];
        this.activeCurrency = currency;
        this.priceChanged = true;
    }
    addCoin(cryptoCurrency) {
        var userData = JSON.parse(localStorage.getItem('user'));
        var appRegion = this.webSettingsService.getWebSetting('APP_REGION');
        if (userData.wallet_blocked) {
            this.compService.openModal(ResetMfaMessageModalComponent);
            return;
        }
        if ((userData.block_transactions || userData.pending_for_document) && appRegion != 'EU') {
            this.compService.openModal(WalletDocumentExpirationModalComponent);
            return;
        }
        if ((!userData.newDataPopulated || !userData.eataandpoaosPopulated) && appRegion != 'EU') {
            this.compService.openModal(UpdateUserDataWalletModalComponent);
        }
        else {
            this.compService.openModal(CoinFiatWalletModalComponent, {
                isCoinModal: true,
                cryptoCurrency: cryptoCurrency
            });
            this.compService.componentRef.onDestroy(() => {
                this.refreshData();
            });
        }
    }
    addFiat(cryptoCurrency) {
        return __awaiter(this, void 0, void 0, function* () {
            var userData = JSON.parse(localStorage.getItem('user'));
            var appRegion = this.webSettingsService.getWebSetting('APP_REGION');
            if (userData.wallet_blocked) {
                this.compService.openModal(ResetMfaMessageModalComponent);
                return;
            }
            if ((userData.block_transactions || userData.pending_for_document) && appRegion != 'EU') {
                this.compService.openModal(WalletDocumentExpirationModalComponent);
                return;
            }
            if ((!userData.newDataPopulated || !userData.eataandpoaosPopulated) && appRegion != 'EU') {
                this.compService.openModal(UpdateUserDataWalletModalComponent);
                return;
            }
            if (this.user['risk_level'] === 'High') {
                yield this.isQuestionnaireSubmitted();
            }
            if (this.questionnaireSubmitted) {
                this.compService.openModal(CoinFiatWalletModalComponent, {
                    isCoinModal: false,
                    cryptoCurrency: cryptoCurrency
                });
                this.compService.componentRef.onDestroy(() => {
                    this.refreshData();
                });
            }
        });
    }
    deposit(walletData) {
        return __awaiter(this, void 0, void 0, function* () {
            var userData = JSON.parse(localStorage.getItem('user'));
            var appRegion = this.webSettingsService.getWebSetting('APP_REGION');
            if ((!userData.newDataPopulated || !userData.eataandpoaosPopulated) && appRegion != 'EU') {
                this.compService.openModal(UpdateUserDataWalletModalComponent);
                return;
            }
            if ((userData.block_transactions || userData.pending_for_document) && appRegion != 'EU') {
                this.compService.openModal(WalletDocumentExpirationModalComponent);
                return;
            }
            if (this.user['risk_level'] === 'High') {
                yield this.isQuestionnaireSubmitted();
            }
            if (this.questionnaireSubmitted) {
                if (walletData.currency.verboseId === 'AUD') {
                    this.httpClient.get('wallet/getfiatdepositpaymentdetails').subscribe((data) => {
                        let user = JSON.parse(localStorage.getItem('user'));
                        let address = user.address ? (', ' + user.address) : '';
                        let city = user.city ? (', ' + user.city) : '';
                        let userDetails = user.name + address + city;
                        const paymentDetails = {
                            accountNumber: data['fiatDepositPaymentDetails']['bank_account'],
                            reference: data['fiatDepositPaymentDetails']['payment_number'],
                            paymentPurpose: data['fiatDepositPaymentDetails']['payment_purpose'],
                            paymentModelCode: data['fiatDepositPaymentDetails']['payment_model_code'],
                            bsb: data['fiatDepositPaymentDetails']['BSB'],
                            receiver: data['fiatDepositPaymentDetails']['account_name'],
                            currency: walletData.currency.verboseId,
                            user: user
                        };
                        this.compService.openModal(DepositWalletAudModalComponent, {
                            accountData: this.accountData,
                            walletData: walletData,
                            paymentDetails: paymentDetails,
                            walletBlocked: userData.wallet_blocked
                        });
                    });
                }
                else {
                    this.compService.openModal(DepositWalletModalComponent, {
                        accountData: this.accountData,
                        walletData: walletData,
                        walletBlocked: userData.wallet_blocked
                    });
                }
            }
        });
    }
    withdraw(walletData, index = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let user = JSON.parse(localStorage.getItem('user'));
            var appRegion = this.webSettingsService.getWebSetting('APP_REGION');
            if (user.wallet_blocked) {
                if (index) {
                    this.toggleActions(index);
                }
                this.compService.openModal(ResetMfaMessageModalComponent);
                return;
            }
            if (yield this.depositOriginService.gate(() => this.withdraw(walletData))) {
                if (index) {
                    this.toggleActions(index);
                }
                return;
            }
            if (this.user['risk_level'] === 'High') {
                yield this.isQuestionnaireSubmitted();
            }
            if (this.questionnaireSubmitted) {
                if (walletData.currency.verboseId === 'AUD') {
                    if (walletData.spendableTotal > 0) {
                        this.compService.openModal(WithdrawWalletAudModalComponent, {
                            accountData: this.accountData,
                            walletData: walletData,
                            user: user
                        });
                        if ((user.block_transactions || user.pending_for_document) && appRegion != 'EU') {
                            this.compService.openModal(WalletDocumentExpirationModalComponent);
                        }
                        if ((!user.newDataPopulated || !user.eataandpoaosPopulated) && appRegion != 'EU') {
                            this.compService.openModal(UpdateUserDataWalletModalComponent);
                            return;
                        }
                    }
                }
                else {
                    if (walletData.spendableTotal > 0) {
                        this.toggleActions(index);
                        if ((user.block_transactions || user.pending_for_document) && appRegion != 'EU') {
                            this.compService.openModal(WalletDocumentExpirationModalComponent);
                            return;
                        }
                        this.modalOpened = true;
                        this.compService.openModal(WithdrawWalletModalComponent, {
                            accountData: this.accountData,
                            walletData: walletData
                        });
                        if ((!user.newDataPopulated || !user.eataandpoaosPopulated) && appRegion != 'EU') {
                            this.compService.openModal(UpdateUserDataWalletModalComponent);
                            return;
                        }
                    }
                }
            }
        });
    }
    buy(walletData, index = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hasFiatSpendableTotal || !this.hasFiatCurrency) {
                return;
            }
            if (index) {
                this.toggleActions(index);
            }
            var userData = JSON.parse(localStorage.getItem('user'));
            var appRegion = this.webSettingsService.getWebSetting('APP_REGION');
            if (userData.wallet_blocked) {
                this.compService.openModal(ResetMfaMessageModalComponent);
                return;
            }
            if ((userData.block_transactions || userData.pending_for_document) && appRegion != 'EU') {
                this.compService.openModal(WalletDocumentExpirationModalComponent);
                return;
            }
            if ((!userData.newDataPopulated || !userData.eataandpoaosPopulated) && appRegion != 'EU') {
                this.compService.openModal(UpdateUserDataWalletModalComponent);
                return;
            }
            if (yield this.depositOriginService.gate(() => this.buy(walletData))) {
                return;
            }
            if (this.user['risk_level'] === 'High') {
                yield this.isQuestionnaireSubmitted();
            }
            if (this.questionnaireSubmitted) {
                this.getFiatWallets();
                this.modalOpened = true;
                this.compService.openModal(BuyWalletModalComponent, {
                    accountData: this.accountData,
                    walletData: walletData,
                    fiatWallets: this.fiatWallets
                });
            }
        });
    }
    sell(walletData, index = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (walletData.spendableTotal > 0 && this.hasFiatCurrency) {
                if (index) {
                    this.toggleActions(index);
                }
                var userData = JSON.parse(localStorage.getItem('user'));
                var appRegion = this.webSettingsService.getWebSetting('APP_REGION');
                if (userData.wallet_blocked) {
                    this.compService.openModal(ResetMfaMessageModalComponent);
                    return;
                }
                if ((userData.block_transactions || userData.pending_for_document) && appRegion != 'EU') {
                    this.compService.openModal(WalletDocumentExpirationModalComponent);
                    return;
                }
                if ((!userData.newDataPopulated || !userData.eataandpoaosPopulated) && appRegion != 'EU') {
                    this.compService.openModal(UpdateUserDataWalletModalComponent);
                    return;
                }
                if (yield this.depositOriginService.gate(() => this.sell(walletData))) {
                    return;
                }
                if (this.user['risk_level'] === 'High') {
                    yield this.isQuestionnaireSubmitted();
                }
                if (this.questionnaireSubmitted) {
                    this.getFiatWallets();
                    this.modalOpened = true;
                    this.compService.openModal(SellWalletModalComponent, {
                        accountData: this.accountData,
                        walletData: walletData,
                        fiatWallets: this.fiatWallets
                    });
                }
            }
        });
    }
    sortWallets(wallets) {
        // sort wallets so that the fiat wallets are first, then the wallets with higher balance, then wallets that have deposit addresses (sorted by name) and then those that don't have deposit addresses (also sorted by name).
        return wallets.sort((a, b) => {
            var _a, _b;
            const name1 = a.currency.name.toLowerCase();
            const name2 = b.currency.name.toLowerCase();
            const balance1 = a.wallet ? a.wallet.wallet.spendableTotal * this.prices[this.activeCurrency + '_prices'][a.currencyShort] : 0;
            const balance2 = b.wallet ? b.wallet.wallet.spendableTotal * this.prices[this.activeCurrency + '_prices'][b.currencyShort] : 0;
            return (b.currency.fiat - a.currency.fiat) || (Number(balance2 > balance1) - Number(balance1 > balance2)) || (Number(!a.wallet) - Number(!b.wallet)) || (Number(!((_a = a.wallet) === null || _a === void 0 ? void 0 : _a.wallet.addresses.length)) - Number(!((_b = b.wallet) === null || _b === void 0 ? void 0 : _b.wallet.addresses.length))) || (Number(name1 > name2) - Number(name2 > name1));
        });
    }
    getFiatWallets() {
        this.fiatWallets = [];
        for (let i = 0; i < this.allWallets.length; i++) {
            if (this.allWallets[i].wallet.currency.fiat) {
                this.fiatWallets.push(this.allWallets[i]);
            }
        }
    }
    getPriceChart(cryptoCurrency) {
        const priceChart = [];
        if (this.priceChart && this.priceChart[cryptoCurrency] && Object.keys(this.priceChart[cryptoCurrency]).length >= 7) {
            for (let i = Object.keys(this.priceChart[cryptoCurrency]).length - 1; i >= 0; i--) {
                if (!this.priceChart[cryptoCurrency][i]) {
                    return [];
                }
                this.priceChart[cryptoCurrency][i].forEach(price => {
                    priceChart.push({ data: price });
                });
            }
        }
        return priceChart;
    }
    getPriceTrend(cryptoCurrency) {
        var _a, _b;
        const priceChart = [];
        if (this.priceChart && this.priceChart[cryptoCurrency] && Object.keys(this.priceChart[cryptoCurrency]).length >= 7
            && ((_a = this.priceChart[cryptoCurrency][6]) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = this.priceChart[cryptoCurrency][0]) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            const oldestStartDayPrice = this.priceChart[cryptoCurrency][6][0];
            const newestEndDayPrice = this.priceChart[cryptoCurrency][0].at(-1);
            if (newestEndDayPrice > oldestStartDayPrice) {
                return 'up';
            }
            else if (newestEndDayPrice < oldestStartDayPrice) {
                return 'down';
            }
            else {
                return 'same';
            }
        }
        return priceChart;
    }
    calculateFiatBalance(wallets, prices, currency) {
        for (let i = 0; i < wallets.length; i++) {
            if (!wallets[i].wallet.currency.fiat && wallets[i].wallet.currency.defaultChain === true) {
                const price = prices[this.defaultCurrency.toLowerCase() + '_prices'][wallets[i].wallet.currency.verboseId.toLowerCase()];
                this.myBalance += wallets[i].wallet.spendableTotal * (price ? price : 0);
            }
            else {
                switch (wallets[i].wallet.currency.verboseId) {
                    case this.defaultCurrency: {
                        this.myBalance += wallets[i].wallet.spendableTotal;
                        break;
                    }
                    case 'USD': {
                        this.myBalance += wallets[i].wallet.spendableTotal * prices['usd_rate'];
                        break;
                    }
                    case 'EUR': {
                        this.myBalance += wallets[i].wallet.spendableTotal * prices['eur_rate'];
                        break;
                    }
                }
            }
        }
        if (currency !== this.defaultCurrency.toLowerCase()) {
            this.myBalance /= prices[currency + '_rate'];
        }
    }
    goToWalletTransactions(walletId, coin, isFiat) {
        if (walletId) {
            localStorage.setItem('walletId', walletId);
            localStorage.setItem('coin', coin);
            localStorage.setItem('isFiat', isFiat ? 'true' : 'false');
            this.router.navigateByUrl('wallet/transactions/coin-details');
        }
    }
    showMore() {
        this.slice = this.slice + this.sliceFromSetting;
    }
    isQuestionnaireSubmitted() {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield this.httpClient.get('market/order/questionnaireFilled?risk_level=' + this.user['risk_level']).toPromise();
            if (!data['isQuestionnaireFilled']) {
                localStorage.setItem('riskLevel', this.user['risk_level']);
                localStorage.setItem("questionnaireSubmitted", "false");
                this.questionnaireSubmitted = false;
                this.router.navigate(['/questionnaire'], { state: { wallet: true } });
            }
        });
    }
    onSeriesAdded(e) {
        if (e.args.series) {
            e.args.series.tooltipTemplate = this.valueTooltip;
        }
    }
    calculateBasketAmount(ecurrencyBasket, amount, currencyPrice) {
        if (ecurrencyBasket['market_settings']) {
            const feePercentage = Number(ecurrencyBasket['market_settings']['fee']);
            const minFee = Number(ecurrencyBasket['market_settings']['min_fee']);
            const fixedFee = Number(ecurrencyBasket['market_settings']['fixed_fee']);
            let fee = ((amount - fixedFee) / 100 * feePercentage) + fixedFee;
            if (minFee > fee) {
                fee = minFee;
            }
            return Number(((amount - fee) / currencyPrice / 100 * (100 - this.marketFee)).toFixed(ecurrencyBasket.allowed_decimals ? ecurrencyBasket.allowed_decimals : this.allowedDecimalPlaces));
        }
        return 0;
    }
    buyBasket(basketId) {
        return __awaiter(this, void 0, void 0, function* () {
            const basket = this.baskets.find(basket => basket.id === basketId);
            if (basket.fiatAmountEnoughForBasket) {
                var userData = JSON.parse(localStorage.getItem('user'));
                if (userData.wallet_blocked) {
                    this.compService.openModal(ResetMfaMessageModalComponent);
                    return;
                }
                if (userData.block_transactions || userData.pending_for_document) {
                    this.compService.openModal(WalletDocumentExpirationModalComponent);
                    return;
                }
                if (!userData.newDataPopulated || !userData.eataandpoaosPopulated) {
                    this.compService.openModal(UpdateUserDataWalletModalComponent);
                    return;
                }
                if (yield this.depositOriginService.gate(() => this.buyBasket(basketId))) {
                    return;
                }
                this.getFiatWallets();
                this.baskets.forEach(basket => {
                    basket.ecurrency_basket.forEach((ecurrencyBasket) => __awaiter(this, void 0, void 0, function* () {
                        const ecurrencyBasketWallet = this.currenciesAndWallets.find(wallet => wallet.currencyShort === ecurrencyBasket.ecurrency.code).wallet;
                        ecurrencyBasket.walletData = ecurrencyBasketWallet ? ecurrencyBasketWallet.wallet : null;
                    }));
                });
                this.compService.openModal(BuyBasketWalletModalComponent, {
                    basket: basket,
                    fiatWallets: this.fiatWallets
                });
            }
        });
    }
    goToBlog() {
        window.open('https://ecd.rs/uputstva/ecd-basket/', '_blank').focus();
    }
    openModalFromRoute() {
        const type = window.history.state.type;
        const exchangeCurrency = window.history.state.currency;
        if (!this.modalOpened) {
            if (this.previousUrl && this.previousUrl.startsWith('/approve')) {
                const currency = this.previousUrl.split('/')[2];
                const wallet = this.currenciesAndWallets.find(wallet => wallet.currencyShort === currency);
                if (wallet && wallet.wallet) {
                    this.withdraw(wallet.wallet.wallet);
                }
            }
            if (type && exchangeCurrency) {
                const wallet = this.currenciesAndWallets.find(wallet => wallet.currencyShort === exchangeCurrency);
                if (wallet && wallet.wallet) {
                    if (type === 'buy') {
                        this.buy(wallet.wallet.wallet);
                    }
                    else {
                        this.sell(wallet.wallet.wallet);
                    }
                }
            }
            this.route.queryParams.subscribe(params => {
                const action = params['action'];
                if (action === 'fiatwithdrawal') {
                    const fiatWallet = this.allWallets.find(wallet => wallet.wallet.currency.fiat === true);
                    if (fiatWallet) {
                        this.withdraw(fiatWallet.wallet);
                    }
                }
            });
        }
    }
    maxDifference(arr) {
        let maxDiff = -1;
        if (arr.length > 0) {
            let min = arr[0]['data'];
            for (let i = 0; i < arr.length - 1; i++) {
                if (arr[i]['data'] > min && maxDiff < arr[i]['data'] - min) {
                    maxDiff = arr[i]['data'] - min;
                }
                if (arr[i]['data'] < min) {
                    min = arr[i]['data'];
                }
            }
        }
        return maxDiff;
    }
    toggleActions(index) {
        this.openIndex = this.openIndex === index ? null : index;
    }
    onDocumentClick(event) {
        if (this.openIndex === null) {
            return;
        }
        const target = event.target;
        const openEls = Array.from(document.querySelectorAll('.is-open'));
        const clickedInsideOpen = openEls.some(el => el.contains(target));
        if (!clickedInsideOpen) {
            this.openIndex = null;
        }
    }
    convert(walletData, index) {
        return __awaiter(this, void 0, void 0, function* () {
            if (walletData.spendableTotal > 0 && this.isCurrencyInConvertPairs(walletData.currency.verboseId.toUpperCase())) {
                if (index) {
                    this.toggleActions(index);
                }
                const userData = JSON.parse(localStorage.getItem('user'));
                const appRegion = this.webSettingsService.getWebSetting('APP_REGION');
                if (userData.wallet_blocked) {
                    this.compService.openModal(ResetMfaMessageModalComponent);
                    return;
                }
                if ((userData.block_transactions || userData.pending_for_document) && appRegion != 'EU') {
                    this.compService.openModal(WalletDocumentExpirationModalComponent);
                    return;
                }
                if ((!userData.newDataPopulated || !userData.eataandpoaosPopulated) && appRegion != 'EU') {
                    this.compService.openModal(UpdateUserDataWalletModalComponent);
                    return;
                }
                if (yield this.depositOriginService.gate(() => this.convert(walletData, null))) {
                    return;
                }
                if (this.user['risk_level'] === 'High') {
                    yield this.isQuestionnaireSubmitted();
                }
                const walletCurrencies = this.wallets.map(w => w.wallet.currency.verboseId);
                const filteredConvertPairs = this.convertCurrencyPairs.filter(pair => walletCurrencies.includes(pair.baseCurrency.code) ||
                    walletCurrencies.includes(pair.quoteCurrency.code));
                if (this.questionnaireSubmitted) {
                    this.compService.openModal(ConvertWalletModalComponent, {
                        accountData: this.accountData,
                        walletData,
                        fiatWallets: this.fiatWallets,
                        wallets: this.allWallets,
                        convertPairs: filteredConvertPairs
                    });
                }
            }
        });
    }
    getPossibleConvertPairs() {
        this.httpClient.get('wallet/getconvertcurrencies').subscribe((data) => {
            this.convertCurrencyPairs = data;
        });
    }
    isCurrencyInConvertPairs(currency) {
        return this.convertCurrencyPairs.some(p => p.baseCurrency.code === currency);
    }
};
WalletCryptocurrenciesComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: ActivatedRoute },
    { type: WebsiteThemeService },
    { type: Router },
    { type: LanguageService },
    { type: WebClientService },
    { type: ComponentService },
    { type: AuthService },
    { type: DepositOriginService }
];
__decorate([
    HostListener('window:resize', ['$event'])
], WalletCryptocurrenciesComponent.prototype, "onResize", null);
__decorate([
    ViewChild('valueTooltip', { static: true })
], WalletCryptocurrenciesComponent.prototype, "valueTooltip", void 0);
__decorate([
    HostListener('document:click', ['$event'])
], WalletCryptocurrenciesComponent.prototype, "onDocumentClick", null);
WalletCryptocurrenciesComponent = __decorate([
    Component({
        selector: 'ecd-wallet-cryptocurrencies',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./wallet-cryptocurrencies.component.html")).default
    })
], WalletCryptocurrenciesComponent);
export { WalletCryptocurrenciesComponent };
